<template>
  <div class="add-step">
    <div class="bg-black add-accont-header">
      <div class="add-brd">
        <div class="h-back" @click="goBackHandler">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </div>
        <h2>انتخاب بانک</h2>
        <p>مرحله بعد: تنظیمات حساب</p>
      </div>
      <div>
        <svg class="header-progresbar">
          <circle class="meter" cx="57" cy="57" r="42" />
          <circle class="meter-0" cx="57" cy="57" r="42" />
          <text class="SVG-text" x="37" y="47">مرحله</text>
          <text x="65" y="74" class="SVG-text">1</text>
          <text x="50" y="74" class="SVG-text">از</text>
          <text x="37" y="74" class="SVG-text">4</text>
        </svg>
      </div>
    </div>
    <div class="add-card">
      <p class="head-step2">:بانک خود را انتخاب کنید</p>
      <div>
        <img
          class="bankLogo"
          v-for="bank in banks"
          :key="bank.bank_id"
          :src="bank.avatar"
          @click="selectBankHandler(bank.name)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.getBanks();
  },
  data() {
    return {
      banks: [],
    };
  },
  computed: {
    apiAdder() {
      return process.env.VUE_APP_MEDIA;
    },
  },
  methods: {
    goBackHandler() {
      this.$router.back();
    },
    getBanks() {
      this.$store.dispatch("accounts/getBanksList").then((rsp) => {
        this.banks = rsp;
        for (var i = 0; i < this.banks.length; i++) {
          this.banks[i].avatar = this.apiAdder + this.banks[i].avatar;
        }
      });
    },
    selectBankHandler(val) {
      this.$store.commit("accounts/setBank", val);
      this.$emit("next");
    },
  },
};
</script>

<style scoped>
.head-step2 {
  margin-top: 50px;
  font-size: 20px;
}
</style>
